import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreatePlanErrorsMapper, CreatePlanMapper } from '../mappers';
import { CreatePlanDto } from '../dtos';

export type ICreatePlanRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreatePlanRepo = IRepo<[CreatePlanDto, string | number | undefined], ICreatePlanRepoResponse>;

export const CreatePlanRepoType = Symbol.for('CreatePlanRepo');

@bind(CreatePlanRepoType)
export class CreatePlanRepo implements ICreatePlanRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreatePlanDto) {
    try {
      const body = new FormData();
      const mappedBody = CreatePlanMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = dto.id ? urlMaker('/api/admin/tariff/edit') : urlMaker('/api/admin/tariff/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreatePlanErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
